import Tone from 'tone';

class SamplerAmplitudeLFO {
    constructor(ampEnvelope) {
        this.input = this.output = new Tone.Gain(1);
    }

    set loop(loop) {
        if (loop && this.lfo === undefined) {
            this.lfo = new Tone.LFO({type: 'triangle', phase:90, min:0.7, max:1});
            this.lfo.connect(this.input.gain);
        } else if (!loop && this.lfo !== undefined) {
            this.lfo.dispose();
            this.lfo = undefined;
        }
    }

    set smooth(min) {
        if (this.lfo) {
            this.lfo.min = min;
        }
    }

    restart(time) {
        if (this.lfo) {
            this.lfo.stop(time);
            this.lfo.start(time);
        }
    }

    onTick(time) {
    }

    // loop length sec
    trigger(time, {loopLengthSeconds}, transpose) {
        if (this.lfo === undefined) {
            return;
        }
        if (loopLengthSeconds <= 0) {
            return;
        }
            
        let freq = Tone.Frequency(loopLengthSeconds, "s")
            .transpose(transpose);
        if (!isNaN(freq) && freq !== undefined) {
            this.lfo.frequency.value = freq;
        }
        this.restart(time);
    }
}

export default SamplerAmplitudeLFO;
